(function () {
  'use strict';

  var script = document.currentScript;
  if (!script || script.dataset.plentumInitialized === 'true') return;
  script.dataset.plentumInitialized = 'true';

  var articleRoot = document.querySelector('article.main-article');
  var articleBody = document.querySelector('.main-article__body');
  if (!articleRoot || !articleBody) return;

  var tracked = {};
  var pending = [];
  var retryTimer = null;
  var retryCount = 0;
  var maxRetries = 40;
  var activeSeconds = 0;
  var activeTimer = null;

  function deviceClass() {
    if (window.innerWidth <= 767) return 'mobile';
    if (window.innerWidth <= 1023) return 'tablet';
    return 'desktop';
  }

  function baseProperties() {
    return {
      article_id: script.dataset.articleId || 'unknown',
      article_path: script.dataset.articlePath || window.location.pathname,
      article_handle: script.dataset.articleHandle || 'unknown',
      blog_handle: script.dataset.blogHandle || 'unknown',
      market: script.dataset.market || 'unknown',
      device: deviceClass(),
      release_cohort: script.dataset.releaseCohort || 'sitewide'
    };
  }

  function setRuntimeState(state) {
    document.documentElement.dataset.plentumArticleAnalytics = state;
  }

  function markSent(eventName) {
    var current = document.documentElement.dataset.plentumArticleEvents || '';
    var events = current ? current.split(',') : [];
    if (events.indexOf(eventName) === -1) {
      events.push(eventName);
      document.documentElement.dataset.plentumArticleEvents = events.join(',');
    }
  }

  function flush() {
    retryTimer = null;

    if (!window.umami || typeof window.umami.track !== 'function') {
      retryCount += 1;
      if (retryCount <= maxRetries && pending.length) {
        setRuntimeState('waiting-for-umami');
        retryTimer = window.setTimeout(flush, 500);
      } else if (pending.length) {
        setRuntimeState('umami-unavailable');
        pending = [];
      }
      return;
    }

    retryCount = 0;
    while (pending.length) {
      var event = pending.shift();
      try {
        window.umami.track(event.name, event.properties);
        markSent(event.name);
      } catch (error) {
        setRuntimeState('track-error');
      }
    }
    if (document.documentElement.dataset.plentumArticleAnalytics !== 'track-error') {
      setRuntimeState('ready');
    }
  }

  function track(eventName, extraProperties) {
    var properties = baseProperties();
    if (extraProperties) {
      Object.keys(extraProperties).forEach(function (key) {
        properties[key] = extraProperties[key];
      });
    }

    pending.push({ name: eventName, properties: properties });
    if (!retryTimer) flush();
  }

  function trackOnce(eventName, extraProperties) {
    if (tracked[eventName]) return;
    tracked[eventName] = true;
    track(eventName, extraProperties);
  }

  function checkArticleScroll() {
    if (tracked.article_scroll_50) return;

    var rect = articleBody.getBoundingClientRect();
    var articleTop = rect.top + window.scrollY;
    var halfwayPoint = articleTop + (articleBody.offsetHeight * 0.5);
    var viewportBottom = window.scrollY + window.innerHeight;

    if (viewportBottom >= halfwayPoint) {
      trackOnce('article_scroll_50');
      window.removeEventListener('scroll', checkArticleScroll);
      window.removeEventListener('resize', checkArticleScroll);
    }
  }

  function handleProductClick(event) {
    if (!(event.target instanceof Element)) return;
    var link = event.target.closest('a[href]');
    if (!link || !articleRoot.contains(link)) return;

    var destination;
    try {
      destination = new URL(link.href, window.location.origin);
    } catch (error) {
      return;
    }

    if (destination.origin !== window.location.origin || destination.pathname.indexOf('/products/') !== 0) return;

    track('article_to_product_click', {
      product_path: destination.pathname.slice(0, 180)
    });
  }

  function startActiveTimer() {
    if (activeTimer) return;
    activeTimer = window.setInterval(function () {
      if (document.visibilityState !== 'visible') return;
      activeSeconds += 1;
      if (activeSeconds >= 30) {
        trackOnce('article_engaged_30s');
        window.clearInterval(activeTimer);
        activeTimer = null;
      }
    }, 1000);
  }

  function stopTimers() {
    if (activeTimer) window.clearInterval(activeTimer);
    if (retryTimer) window.clearTimeout(retryTimer);
  }

  setRuntimeState('initialized');
  trackOnce('article_view');
  checkArticleScroll();
  startActiveTimer();

  window.addEventListener('scroll', checkArticleScroll, { passive: true });
  window.addEventListener('resize', checkArticleScroll, { passive: true });
  document.addEventListener('click', handleProductClick);
  window.addEventListener('pagehide', stopTimers, { once: true });
}());
